/**
 * XRayExportPollerInit
 *
 * Headless component — renders nothing, mounts once at the app root so the
 * XRay export poller survives route navigation. Mirrors the pattern used by
 * BackgroundChatListener and RunStreamInit.
 */
import useXRayExportPoller from '../../../hooks/useXRayExportPoller';

const XRayExportPollerInit = () => {
  useXRayExportPoller();
  return null;
};

export default XRayExportPollerInit;
